import { api, unwrap } from '@/data/api/client';
import type {
  Platform, Service, Category, BuyResult, OrdersPage,
} from '@/domain/types';
import { config } from '@/config';

export const catalogRepo = {
  platforms: async (): Promise<Platform[]> =>
    (await unwrap<{ platforms?: Platform[] }>(api.GET('/services', {}))).platforms ?? [],

  services: async (platformId: number): Promise<Service[]> =>
    (await unwrap<{ services?: Service[] }>(api.GET('/services/{id}', {
      params: { path: { id: platformId } },
    }))).services ?? [],

  categories: async (platformId?: number): Promise<Category[]> =>
    (await unwrap<{ categories?: Category[] }>(api.GET('/services/categories', {
      params: { query: { platformId } },
    }))).categories ?? [],

  // Relevance-ranked search across every platform (closest matches first).
  search: async (q: string, limit?: number): Promise<Service[]> =>
    (await unwrap<{ services?: Service[] }>(api.GET('/services/search', {
      params: { query: { q, ...(limit ? { limit } : {}) } },
    }))).services ?? [],

  orders: (page = 1, pageSize = config.orders.pageSize) =>
    unwrap<OrdersPage>(api.GET('/services/orders', {
      params: { query: { page, pageSize } },
    })),

  buy: (body: {
    serviceId: number;
    amount: number;
    link: string;
    notifEmail?: string;
    description?: string;
    meta?: string;
  }) =>
    unwrap<BuyResult>(api.POST('/services/buy', {
      body: {
        serviceId: body.serviceId,
        amount: body.amount,
        link: body.link,
        notifEmail: body.notifEmail ?? null,
        description: body.description ?? null,
        meta: body.meta ?? null,
      },
    })),
};
